import { render, staticRenderFns } from "./WarnBanner.vue?vue&type=template&id=4a91047e"
import script from "./WarnBanner.vue?vue&type=script&lang=js"
export * from "./WarnBanner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports